export const getValue = measurement => {
  if (!measurement) {
    return undefined;
  }

  const result = parseFloat(measurement.value);
  const isInvalid = isNaN(result);

  if (isInvalid) {
    return undefined;
  }

  return result;
};
//# sourceMappingURL=internal.js.map